import { css, useMaxHeight } from '@obvio/app'
import { useMemo } from 'react'

import { Section, Title } from './HeroSection/components'
import { Map511 } from './HeroSection/Map511'

import type { ReactElement } from 'react'

type HeroMapSectionProps = {
  title: string
}

export function HeroMapSection({ title }: HeroMapSectionProps): ReactElement {
  const maxHeightRef = useMaxHeight()
  const sectionCss = useMemo(
    () => css`
      background: ${(theme) => theme.colors.secondary};
      overflow: hidden;
      border-bottom: 1px solid ${(theme) => theme.stroke};
    `,
    [],
  )
  return (
    <Section ref={maxHeightRef} outerCss={sectionCss}>
      <Map511 />
      <Title tag="h1">{title}</Title>
    </Section>
  )
}
